import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const VisibilityDark: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 18 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.27532 2.54692L2.19452 4.85119V4.01183C2.12966 3.48439 2.18854 2.95025 2.3669 2.44797C2.54525 1.94569 2.83881 1.48954 3.22453 1.11387C3.61025 0.737375 4.0796 0.451437 4.59589 0.276185C5.11132 0.101771 5.6626 0.0422356 6.20619 0.103448H11.5781C12.1209 0.0422356 12.6713 0.101771 13.1876 0.276185C13.7039 0.451437 14.1724 0.737375 14.5581 1.11304C14.9438 1.4887 15.2374 1.94402 15.4157 2.44546C15.5941 2.9469 15.6538 3.48104 15.5898 4.00764V4.83526L11.509 2.54189C10.7051 2.11843 9.80569 1.89706 8.89174 1.8979C7.97778 1.8979 7.07833 2.12179 6.27532 2.54608V2.54692Z"
        fill="#45D88E"
      />
      <path
        d="M15.7793 6.84284L15.62 6.75193L14.0359 5.84287L10.7666 3.96043C10.2217 3.67571 9.61599 3.52734 9 3.52734C8.38401 3.52734 7.7783 3.67571 7.23341 3.96043L3.96411 5.84287L2.38001 6.76051L2.17525 6.87628C0.137934 8.23558 0 8.48515 0 10.6737V15.8991C0 18.0869 0.137078 18.3364 2.22151 19.7309L7.23341 22.615C7.77401 22.9109 8.38315 23.0584 9 23.0447C9.61685 23.0558 10.226 22.9057 10.7666 22.6107L15.8239 19.6966C17.8629 18.3364 18 18.0869 18 15.9V10.6746C18 8.486 17.8629 8.23644 15.7785 6.84369L15.7793 6.84284Z"
        fill="#1B3029"
      />
      <path
        d="M11.3176 11.251C10.5888 10.8223 9.79762 10.5977 8.98194 10.5977C6.20385 10.5977 4.65448 13.1809 4.59766 13.2354C4.66077 13.2959 6.1222 15.8751 8.98194 15.8751C11.76 15.8751 13.3177 13.2819 13.3662 13.2354C13.2789 13.1323 12.6598 12.0383 11.3176 11.251ZM8.98194 15.1406C7.93213 15.1406 7.07868 14.2871 7.07868 13.2373C7.07868 12.1875 7.93213 11.334 8.98194 11.334C10.0317 11.334 10.8852 12.1875 10.8852 13.2373C10.8852 14.2871 10.0317 15.1406 8.98194 15.1406Z"
        fill="white"
      />
      <path
        d="M9.39117 12.8235C9.10319 12.5355 9.18384 12.1981 9.17082 12.1016H8.98201C8.3573 12.1016 7.84912 12.6097 7.84912 13.2345C7.84912 13.8485 8.36799 14.3674 8.98201 14.3674C9.60672 14.3674 10.1149 13.8592 10.1149 13.2345V13.0456C10.0164 13.0322 9.68026 13.1122 9.39117 12.8235Z"
        fill="white"
      />
      <path d="M8.79248 9.27539H9.17011V10.0361H8.79248V9.27539Z" fill="white" />
      <path d="M11.4878 10.4648L12.0258 9.92679L12.2929 10.1938L11.7548 10.7319L11.4878 10.4648Z" fill="white" />
      <path d="M5.66895 10.1973L5.93597 9.93024L6.47389 10.4682L6.20687 10.7352L5.66895 10.1973Z" fill="white" />
      <path d="M8.79248 16.4375H9.17011V17.1984H8.79248V16.4375Z" fill="white" />
      <path d="M5.66748 16.2793L6.2054 15.7414L6.47243 16.0084L5.9345 16.5463L5.66748 16.2793Z" fill="white" />
      <path d="M11.4868 16.0098L11.7538 15.7427L12.2919 16.2808L12.0249 16.5478L11.4868 16.0098Z" fill="white" />
    </svg>
  )
})

VisibilityDark.displayName = 'VisibilityDark'
